import { useState } from 'react';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useWishlist } from '@/hooks/useWishlist';
import { toast } from 'sonner';

interface Props {
  handle: string;
  name: string;
  className?: string;
}

/** Save/Saved wishlist toggle. Instant, no confirmation; teacher is never notified. */
export function SaveTeacherButton({ handle, name, className }: Props) {
  const { isSaved, toggle } = useWishlist();
  const [saved, setSaved] = useState(() => isSaved(handle));

  const handleClick = async () => {
    try {
      const next = await toggle(handle, name);
      setSaved(next);
      toast.success(next ? `Saved ${name}` : `Removed ${name}`);
    } catch {
      toast.error('Could not update your saved teachers. Please try again.');
    }
  };

  return (
    <Button variant="outline" className={className} onClick={() => void handleClick()}>
      <Heart className={cn('w-4 h-4 mr-1.5', saved && 'fill-rose-500 text-rose-500')} />
      {saved ? 'Saved' : 'Save'}
    </Button>
  );
}
